import Plx from "../_modules/_Plx";

const Strength = () => {


  window.addEventListener('load',()=>{
    new Plx('strength',1);
  })
}

export default Strength;